// extracted by mini-css-extract-plugin
export default {"barcodes":"barcode-list_barcodes__mO6kp","new":"barcode-list_new__EdPi8","pulse":"barcode-list_pulse__9TIZx"};